// extracted by mini-css-extract-plugin
export default {"quickSearchBarWrap":"quickSearchBar_quickSearchBarWrap__zvc32","quickSearchBarWrapFixed":"quickSearchBar_quickSearchBarWrapFixed__a8gY9"};